// extracted by mini-css-extract-plugin
export var truncate = "_x-0";